import Vue from 'vue'
import Router from 'vue-router'

// 导入组件
import Login from '../view/Login.vue'
import Register from '../view/Register.vue'
import Agreement from '../view/Agreement.vue'
import PersonalLike from '../view/PersonalLike.vue'
import CreatorCenter from '../view/CreatorCenter.vue'
import Home from '../view/Home.vue'
import About from '../view/About.vue'
import News from '../view/News.vue'
import OfficialRecommend from '../view/OfficialRecommend.vue'
import GuessLike from '../view/GuessLike.vue'
import PopularArtists from '../view/PopularArtists.vue'
import LatformHypertalk from '../view/LatformHypertalk.vue'
import MsgCenter from '../view/MsgCenter.vue'
import MsgDetails from '../view/MsgDetails.vue'
import CommonProblem from '../view/CommonProblem.vue'
import SuperTalkCommunity from '../view/SuperTalkCommunity.vue'
import SuperTalkDetails from '../view/SuperTalkDetails.vue'
import MsgToSuperTalkDetails from '../view/MsgToSuperTalkDetails.vue'
import CreatorFlowerMarket from '../view/CreatorFlowerMarket.vue'
import WorkDetails from '../view/WorkDetails.vue'
import BuyNow from '../view/BuyNow.vue'
import PainterHomepage from '../view/PainterHomepage.vue'
import WonderfulActivities from '../view/WonderfulActivities.vue'
import ActivitiesDetails from '../view/ActivitiesDetails.vue'
import SurroundingMarkets from '../view/SurroundingMarkets.vue'
import MarketsDetails from '../view/MarketsDetails.vue'
import MarketsBuy from '../view/MarketsBuy.vue'
import PersonalCenter from '../view/PersonalCenter.vue'
import PersonalCenterPhone from '../view/PersonalCenterPhone.vue'
import OrderDetails from '../view/OrderDetails.vue'
import MyOrderDetails from '../view/MyOrderDetails.vue'
import DataBoard from '../view/Painter/DataBoard.vue'
import PainterUserInfo from '../view/Painter/PainterUserInfo.vue'
import PainterWorks from '../view/Painter/PainterWorks.vue'
import PainterWorkDetails from '../view/Painter/PainterWorkDetails.vue'
import PainterImgOrder from '../view/Painter/PainterImgOrder.vue'
import PainterFans from '../view/Painter/PainterFans.vue'
import PainterPublish from '../view/Painter/PainterPublish.vue'
import PainterIncome from '../view/Painter/PainterIncome.vue'
import PainterSuperTalk from '../view/Painter/PainterSuperTalk.vue'
import PainterSuperTalkDetails from '../view/Painter/PainterSuperTalkDetails.vue'
import PainterUpdates from '../view/Painter/PainterUpdates.vue'
import PainterMineTalk from '../view/Painter/PainterMineTalk.vue'
import PainterChat from '../view/Painter/PainterChat.vue'
import PainterMakeOrder from '../view/Painter/PainterMakeOrder.vue'
import PainerOrderDetails from '../view/Painter/PainerOrderDetails.vue'
import PainterMakeOrderDetails from '../view/Painter/PainterMakeOrderDetails.vue'
import PainerMsgCenter from '../view/Painter/PainerMsgCenter.vue'
import PainterMsgDetails from '../view/Painter/PainterMsgDetails.vue'
import PainterMsgSuperDetails from '../view/Painter/PainterMsgSuperDetails.vue'
import PopularRecommend from '../view/PopularRecommend.vue'
import WorksList from '../view/WorksList.vue'

// 注册路由插件
Vue.use(Router)

// 定义路由配置
const router = new Router({
	mode: 'hash', // 使用history模式，去掉URL中的#
	routes: [{
			path: '/',
			name: 'WorksList',
			component: WorksList,
			meta: {
				title: '作品列表'
			}
		},
		{
			path: '/home',
			name: 'Home',
			component: Home,
		},
		{
			path: '/about',
			name: 'About',
			component: About
		},
		{
			path: '/news',
			name: 'News',
			component: News
		},
		{
			path: '/official-recommend',
			name: 'OfficialRecommend',
			component: OfficialRecommend
		},
		{
			path: '/guess-like',
			name: 'GuessLike',
			component: GuessLike
		},
		{
			path: '/popular-artists',
			name: 'PopularArtists',
			component: PopularArtists
		},
		{
			path: '/latform-hypertalk',
			name: 'LatformHypertalk',
			component: LatformHypertalk
		},
		{
			path: '/msg-center',
			name: 'MsgCenter',
			component: MsgCenter
		},
		{
			path: '/msg-details',
			name: 'MsgDetails',
			component: MsgDetails
		},
		{
			path: '/common-problem',
			name: 'CommonProblem',
			component: CommonProblem
		},
		{
			path: '/register',
			name: 'Register',
			component: Register
		},
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			path: '/agreement',
			name: 'Agreement',
			component: Agreement
		},
		{
			path: '/creator-center',
			name: 'CreatorCenter',
			component: CreatorCenter
		},
		{
			path: '/personal-like',
			name: 'PersonalLike',
			component: PersonalLike
		},
		{
			path: '/super-talk-community',
			name: 'SuperTalkCommunity',
			component: SuperTalkCommunity
		},
		{
			path: '/super-talk-details',
			name: 'SuperTalkDetails',
			component: SuperTalkDetails
		},
		{
			path: '/msg-super-talk-details',
			name: 'MsgToSuperTalkDetails',
			component: MsgToSuperTalkDetails
		},
		{
			path: '/creator-flower-market',
			name: 'CreatorFlowerMarket',
			component: CreatorFlowerMarket,
			meta: {
				title: '创作者花市',
			}
		},
		{
			path: '/work-details',
			name: 'WorkDetails',
			component: WorkDetails,
			meta: {
				title: '作品详情'
			}
		},
		{
			path: '/buy-now',
			name: 'BuyNow',
			component: BuyNow,
			meta: {
				title: '立即购买'
			}
		},
		{
			path: '/painter-homepage',
			name: 'PainterHomepage',
			component: PainterHomepage,
			meta: {
				title: '画师主页'
			}
		},
		{
			path: '/wonderful-activities',
			name: 'WonderfulActivities',
			component: WonderfulActivities,
			meta: {
				title: '精彩活动'
			}
		},
		{
			path: '/activities-details',
			name: 'ActivitiesDetails',
			component: ActivitiesDetails,
			meta: {
				title: '精彩活动详情'
			}
		},
		{
			path: '/surrounding-markets',
			name: 'SurroundingMarkets',
			component: SurroundingMarkets,
			meta: {
				title: '周边市场'
			}
		},
		{
			path: '/markets-details',
			name: 'MarketsDetails',
			component: MarketsDetails,
			meta: {
				title: '周边市场详情'
			}
		},
		{
			path: '/markets-buy',
			name: 'MarketsBuy',
			component: MarketsBuy,
			meta: {
				title: '立即购买'
			}
		},
		{
			path: '/personal-center',
			name: 'PersonalCenter',
			component: PersonalCenter,
			meta: {
				title: '个人中心'
			}
		},
		{
			path: '/personal-center-phone',
			name: 'PersonalCenterPhone',
			component: PersonalCenterPhone,
			meta: {
				title: '个人中心'
			}
		},
		{
			path: '/order-details',
			name: 'OrderDetails',
			component: OrderDetails,
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/my-order-details',
			name: 'MyOrderDetails',
			component: MyOrderDetails,
			meta: {
				title: '我的订单详情'
			}
		},
		{
			path: '/data-board',
			name: 'DataBoard',
			component: DataBoard,
			meta: {
				title: '数据仪表盘'
			}
		},
		{
			path: '/user-info',
			name: 'PainterUserInfo',
			component: PainterUserInfo,
			meta: {
				title: '个人信息'
			}
		},
		{
			path: '/works',
			name: 'PainterWorks',
			component: PainterWorks,
			meta: {
				title: '作品管理'
			}
		},
		{
			path: '/painter-works-details',
			name: 'PainterWorkDetails',
			component: PainterWorkDetails,
			meta: {
				title: '作品详情'
			}
		},
		{
			path: '/painter-img-order',
			name: 'PainterImgOrder',
			component: PainterImgOrder,
			meta: {
				title: '正常图片订单'
			}
		},
		{
			path: '/painter-make-order',
			name: 'PainterMakeOrder',
			component: PainterMakeOrder,
			meta: {
				title: '定制图片订单'
			}
		},
		{
			path: '/painter-order-details',
			name: 'PainerOrderDetails',
			component: PainerOrderDetails,
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/painter-make-order-details',
			name: 'PainterMakeOrderDetails',
			component: PainterMakeOrderDetails,
			meta: {
				title: '订单详情'
			}
		},
		{
			path: '/fans',
			name: 'PainterFans',
			component: PainterFans,
			meta: {
				title: '粉丝'
			}
		},
		{
			path: '/piblish',
			name: 'PainterPublish',
			component: PainterPublish,
			meta: {
				title: '发布作品'
			}
		},
		{
			path: '/income',
			name: 'PainterIncome',
			component: PainterIncome,
			meta: {
				title: '我的收入'
			}
		},
		{
			path: '/painter-super-talk',
			name: 'PainterSuperTalk',
			component: PainterSuperTalk,
			meta: {
				title: '超话社区'
			}
		},
		{
			path: '/painter-super-talk-details',
			name: 'PainterSuperTalkDetails',
			component: PainterSuperTalkDetails,
			meta: {
				title: '超话社区详情'
			}
		},
		{
			path: '/painter-updates',
			name: 'PainterUpdates',
			component: PainterUpdates,
			meta: {
				title: '我的动态'
			}
		},
		{
			path: '/painter-mine-talk',
			name: 'PainterMineTalk',
			component: PainterMineTalk,
			meta: {
				title: '我的超话'
			}
		},
		{
			path: '/painter-chat',
			name: 'PainterChat',
			component: PainterChat,
			meta: {
				title: '我的聊天'
			}
		},
		{
			path: '/painter-msg-center',
			name: 'PainerMsgCenter',
			component: PainerMsgCenter,
			meta: {
				title: '消息中心'
			}
		},
		{
			path: '/painter-msg-details',
			name: 'PainterMsgDetails',
			component: PainterMsgDetails,
			meta: {
				title: '消息详情'
			}
		},
		{
			path: '/painter-msg-super-details',
			name: 'PainterMsgSuperDetails',
			component: PainterMsgSuperDetails,
			meta: {
				title: '超话详情'
			}
		},
		{
			path: '/popular-recommend',
			name: 'PopularRecommend',
			component: PopularRecommend,
			meta: {
				title: '热门推荐'
			}
		},
		// {
		// 	path: '/works-list',
		// 	name: 'WorksList',
		// 	component: WorksList,
		// 	meta: {
		// 		title: '作品列表'
		// 	}
		// }
	]
})

router.afterEach((to) => {
	console.log(to)
	if (window.innerWidth <= 480) {
		if (['/login', '/register'].includes(to.path)) {
			document.documentElement.style.fontSize = 360 * (window.innerWidth / 1920) + 'px';
		} else {
			document.documentElement.style.fontSize = 150 * (window.innerWidth / 1920) + 'px';
		}
	} else {
		document.documentElement.style.fontSize = 100 * (window.innerWidth / 1920) + 'px';
	}
})

export default router